import React from "react";
import Tooltip from "./Tooltip";

export interface LabelProps
    extends React.DetailedHTMLProps<React.LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement> {
    disabled?: boolean;
    disabledClassName?: string;
    error?: boolean;
    errorClassName?: string;
    required?: boolean;
    requiredSymbole?: string;
    tooltip?: string;
}

const Label: React.FC<LabelProps> = ({
    children,
    required,
    requiredSymbole = "\u00a0*",
    error,
    errorClassName = "error",
    className = "field__label",
    disabled,
    disabledClassName,
    tooltip,
    ...props
}) => {
    return (
        <label
            className={`${className} ${disabled && disabledClassName ? disabledClassName : ""} ${
                error ? errorClassName : ""
            }`.trim()}
            {...props}
        >
            {children}
            {required && <span className="field__label--required">{requiredSymbole}</span>}
            {tooltip && (
                <React.Fragment>
                    {" "}
                    <Tooltip value={tooltip} />
                </React.Fragment>
            )}
        </label>
    );
};

export default Label;
